import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c5e3cb88")

_pushScopeId("data-v-c5e3cb88")
const _hoisted_1 = { class: "recommend-food-line" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RecommendFoodItem = _resolveComponent("RecommendFoodItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item, index) => {
      return (_openBlock(), _createBlock(_component_RecommendFoodItem, {
        class: "recommend-food-line-item-view",
        key: index,
        data: item,
        onSelectFood: _ctx.selectFood
      }, null, 8, ["data", "onSelectFood"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})